import React, {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';

import {
  BASE_ROUTE,
  BASE_ROUTE_MODULE,
  BASE_ROUTE_SUB_MODULE,
  BASE_RECORD_ID,
  PARAMS_KEY,
  BASE_MENU_ITEM,
  BASE_LEGACY_APP,
  BASE_UNIQUE_ID,
  BASE_SPECIMEN_NUMBER,
  BASE_SPECIMEN_NUMBER_ID,
  BASE_SPECIMEN_TYPE,
  BASE_DEMOGRAPHIC_ID,
  BASE_PROCEDURE_ID,
  ASSET_INFO_ID,
  BASE_ACCESSION_NUMBER
} from 'src/routes/BaseRoute';
import {GridEventListener} from '@mui/x-data-grid-premium';
import CollapsibleTable from '../../sub-modules-menu/collapsible-table/CollapsibleTable';
import EncryptUtils from 'src/utils/EncryptUtils';
import AuthUtils from 'src/utils/AuthUtils';
import {generateRandomString} from 'src/utils/helperUtils';
import GlobalSearchDialog from '@components/dialog/global-search-dialog/GlobalSearchDialogView';

interface ModuleSearchResultsProps {
  module: any;
  uiFieldsData: any;
  data: any;
  totalCount: number;
  onPageChange?: (value: number) => void;
  onPageSizeChange?: (value: number) => void;
  onLegacySystemChange?: (value: string) => void;
  pageSize: number;
  changeLegacySystem?: string;
  handleSortModelChange?: any;
  menuItem?: any;
  rowsCount?: number;
  searchFormFieldsData: any;
  // eslint-disable-next-line react/boolean-prop-naming
  loading?: boolean;
  handleEditUser?: (data: any) => void;
  handleDeleteUser?: (data: any) => void;
  pinnedRowsData?: any;
}

const ModuleSearchResults = (
  props: ModuleSearchResultsProps
): React.ReactElement => {
  const {
    uiFieldsData,
    data: rowsList = [],
    rowsCount,
    searchFormFieldsData,
    handleEditUser,
    handleDeleteUser,
    pinnedRowsData
  } = props;
  const {fields} = uiFieldsData;
  const navigate = useNavigate();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogData, setDialogData] = useState<Record<string, any>>({});
  const [currentSubSection, setCurrentSubSection] = useState<any>(null);

  useEffect(() => {
    if (Object.keys(fields).length) {
      // getColumns();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uiFieldsData]);

  const editUser = (data: any): void => {
    if (handleEditUser && typeof handleEditUser === 'function') {
      handleEditUser(data);
    }
  };

  const deleteUser = (data: any) => {
    if (handleDeleteUser && typeof handleDeleteUser === 'function') {
      handleDeleteUser(data);
    }
  };

  const colList = uiFieldsData?.search_results;

  const handleCellClick: GridEventListener<'cellClick'> = params => {
    // console.log('function calling..msr.',params?.row?.LegacyApp);

    if (params?.row?.AccountNumber || params?.row?.EncounterNumber) {
      localStorage.setItem('account_number_id', params?.row?.AccountNumber);
      localStorage.setItem('encounter_number_id', params?.row?.EncounterNumber);
      localStorage.setItem('account_number_date', params?.row?.EncounterDate);
      localStorage.setItem('account_number_Date_id', params?.row?.EncounterID);
      localStorage.setItem(
        'account_number_Legacy_App',
        params?.row?.EncounterLegacyApp
      );
      localStorage.setItem(
        'account_number_Legacy_Mrn',
        params?.row?.EncounterLegacyMRN
      );
      localStorage.setItem('account_number_fetched', 'false');
    }
    if (params?.row?.InvoiceNumber) {
      localStorage.setItem('invoice_number', params?.row?.InvoiceNumber);
    } else {
      localStorage.removeItem('invoice_number');
    }

    const paramsKey = EncryptUtils.setEncryptedParams({
      [BASE_UNIQUE_ID]:
        params?.row?.InvoiceNumber ||
        params?.row?.ContractNO ||
        params?.row?.PONumber,
      [BASE_RECORD_ID]:
        params?.row?.AssetInfoID ||
        params?.row?.ARInvoiceInfoID ||
        params?.row?.ARPaymentInfoID ||
        params?.row?.ReconciliationInfoID ||
        params?.row?.Year ||
        params?.row?.EmpNo ||
        params?.row?.PayDate ||
        params?.row?.PatientID ||
        params?.row?.VendorID ||
        params?.row?.ItemVendorID ||
        params?.row.InvoiceID ||
        params?.row?.LegacyMRN ||
        params?.row?.UserID ||
        params?.id,
      [BASE_LEGACY_APP]: params?.row?.LegacyApp,
      [BASE_SPECIMEN_NUMBER]: params?.row?.SpecimenNumber,
      [BASE_ACCESSION_NUMBER]:params?.row?.AccessionNumber,
      [BASE_SPECIMEN_NUMBER_ID]: params?.row?.SpecimenID,
      [BASE_SPECIMEN_TYPE]: params?.row?.OrderType,
      [BASE_DEMOGRAPHIC_ID]: params?.row?.DemographicID,
      [BASE_PROCEDURE_ID]: params?.row?.ProcedureID,
      [ASSET_INFO_ID]: params?.row?.AssetInfoID
    });

    for (const field of colList.fields) {
      if (params?.field === field.data_column && field?.is_clickable) {
        if (field?.dialog_view === true) {
          // If dialog view is true, open Dialog instead of navigation
          setDialogData(params.row);
          const subSection = colList?.sub_sections?.find(
            (sec: any) => sec.name === 'ai_document_viewer_result'
          );
          setCurrentSubSection(subSection);
          setDialogOpen(true);
        } else {
          AuthUtils.setAuditIdentifier(params?.value);
          AuthUtils.setAuditIdentifierType(params?.colDef?.headerName);
          AuthUtils.setAuditLegacyApp(params?.row?.LegacyApp);
          let url = '';
          if (params?.row?.EncounterNumber && props?.module === 'clinical') {
            url = `/${BASE_ROUTE}/${BASE_ROUTE_MODULE}/${props?.module}/${BASE_ROUTE_SUB_MODULE}/encounters?${PARAMS_KEY}=${paramsKey}`;
          } else if (field?.parent_path) {
            url = `/${BASE_ROUTE}/${BASE_ROUTE_MODULE}/${props?.module}/${BASE_ROUTE_SUB_MODULE}/${field?.parent_path}?${PARAMS_KEY}=${paramsKey}`;
          } else {
            url = `/${BASE_ROUTE}/${BASE_ROUTE_MODULE}/${props?.module}/${BASE_ROUTE_SUB_MODULE}?${PARAMS_KEY}=${paramsKey}`;
          }
          if (props?.menuItem) {
            url += `&${BASE_MENU_ITEM}=${props.menuItem}`;
          }
          AuthUtils.clearAdditionalSelectedCheckBoxList();
          // AuthUtils.clearPatientAccountingSelectedCheckBoxList();
          AuthUtils.clearSelectedAdditionalCheckBoxData();
          AuthUtils.clearSelectedPatientAccountingCheckBoxData();
          localStorage.removeItem('PATabledata');
          navigate(url);
          sessionStorage.removeItem('@searchQuery');
          sessionStorage.removeItem('@toastPath');
        }
      }
    }
  };

  return (
    <>
      <CollapsibleTable
        key={`${generateRandomString(10)}_${new Date().toISOString()}`}
        sectionUIData={colList}
        sectionRowsData={rowsList}
        onCellClick={handleCellClick}
        module={props?.module}
        isFromModules={true}
        searchFormFieldsData={searchFormFieldsData}
        rowsCount={rowsCount}
        loading={props?.loading}
        handleEditUser={editUser}
        handleDeleteUser={deleteUser}
        pinnedRowsData={pinnedRowsData}
      />

      {dialogOpen && (
        <GlobalSearchDialog
          open={dialogOpen}
          onClose={() => setDialogOpen(false)}
          rowData={dialogData}
          subSectionData={currentSubSection}
          module={props.module}
          sub_module={'global-search'}
        />
      )}
    </>
  );
};

export default ModuleSearchResults;
